import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  slsRtnFServ02ShowSyncSetting: null,
  slsRtnFServ02ShowSyncSettingLoading: ['boolean'],
  slsRtnFServ02ShowSyncSettingSuccess: ['syncSetting'],
  slsRtnFServ02UpdateSyncSetting: ['formikBag', 'syncSetting'],
  slsRtnFServ02ShowBatchJobStatus: null,
  slsRtnFServ02ShowBatchJobStatusSuccess: ['batchJobStatus'],

  slsRtnFServ02ResetTimestamp: ['currentPage', 'sorts', 'filters', 'pageSize'],
  slsRtnFServ02GoToDocument: ['hdrId'],
  slsRtnFServ02FetchSlsRtnFServ02: ['currentPage', 'sorts', 'filters', 'pageSize'],
  slsRtnFServ02FetchSlsRtnFServ02Loading: ['boolean'],
  slsRtnFServ02FetchSlsRtnFServ02Success: [
    'documents',
    'currentPage',
    'lastPage',
    'total',
    'pageSize'
  ],
  slsRtnFServ02AddSelectedDocuments: ['selectedDocuments'],
  slsRtnFServ02RemoveSelectedDocuments: ['selectedDocuments'],
  slsRtnFServ02SetWorkspaceVisible: ['boolean'],

  slsRtnFServ02Export: ['hdrIds'],
  slsRtnFServ02ExportSuccess: null,
  slsRtnFServ02ExportLoading: ['boolean']
});

export const SlsRtnFServ02Types = Types;
export default Creators;
